// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6d12e3de","453":"a34aac51","455":"80584fc8"}[chunkId] + ".chunk.js";
};